import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

import ConfirmationModal from "../../../../../components/Dialogs/ConfirmationModal";

interface ModalTextDescriptionInfoProps {
  color?: string;
}

export const ChangeOrderStatusConfirmationModal = styled(ConfirmationModal)({
  width: "520px !important",
});

export const ModalTextDescriptionInfo = styled("span")(
  ({ color = colors.gray800 }: ModalTextDescriptionInfoProps) => ({
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    color,
  })
);

export const ConfirmationModalWarningBody = styled("div")(() => ({
  display: "flex",
  paddingTop: "8px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));
